import React, { useState } from 'react';
import { addScheduleToSupplier } from 'services/api/suppliers';
import { showError } from 'utils';
import styles from './index.module.scss';

const SupplierSchedule = props => {
  let { schedule } = props;
  const {
    supplierId,
    onChange,
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const keys = Object.keys(schedule);
  
  const updateSupplierScheduleFn = async (day: string, checked: boolean) => {
    setLoading(true);
    schedule = {
      ...schedule,
      [day]: checked,
    };
    try {
      await addScheduleToSupplier({
        supplierId,
        schedule,
      });
      onChange(schedule);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className={'mt-3'}>
      {
        keys.map((key, i) => (
          <div key={i} className={styles['day-group']}>
            <input
              type={'checkbox'}
              disabled={loading}
              checked={schedule[key]}
              onChange={e => updateSupplierScheduleFn(key, e.target.checked)}
            />
            <div className={styles['day-name']}>{key}</div>
          </div>
        ))
      }
    </div>
  );
};

export default SupplierSchedule;
